import * as React from 'react';
import Loader from '../common/Loader';
import { withRouter } from 'react-router';
import { fetchLogoAndId } from 'src/api/login';
import { getLoginRoute } from 'src/routing/utils';

class LoginFromInternal extends React.Component<any, any> {
  async componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    if (
      searchParams.has('authToken') &&
      searchParams.has('organisationId') &&
      searchParams.has('userId')
    ) {
      const storage = window.localStorage;
      storage.setItem('organisationId', searchParams.get('organisationId') || '');
      storage.setItem('userId', searchParams.get('userId') || '');
      storage.setItem('authToken', searchParams.get('authToken') || '');
      storage.setItem('lastActionTime', String(new Date()));
      this.props.history.push('/');
    } else {
      window.location.href = getLoginRoute();
    }
    const response = await fetchLogoAndId();
    if (response.isSuccess) {
      window.localStorage.logoUrl = response.data.logoUrl;
      window.localStorage.setItem('isTestOrg', response.data.isTestOrg);
      window.localStorage.setItem('isDevrevEnabled', response.data.isDevrevEnabled);
    }
  }

  render() {
    return <Loader />;
  }
}

export default withRouter(LoginFromInternal);
